// @flow
import * as React from 'react';
import { renderToString } from 'react-dom/server';
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { p } from 'styled-components-spacing';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

import theme from '@theme';

const { colors } = theme;

export const StyledCover = styled.div`
  ${({ bottomArrows }) => bottomArrows && bottomArrowsStyles}
`;

const solidPrevArrow = css`
  border-right: 16px solid ${({ activeColor }) => activeColor || colors.aquaMarine};
`;

const solidNextArrow = css`
  border-left: 16px solid ${({ activeColor }) => activeColor || colors.aquaMarine};
`;

const chevronArrowBaseStyles = css`
  position: absolute;
  width: 9px;
  bottom: -10px;
`;

const chevronPrevArrow = css`
  ${chevronArrowBaseStyles}
  /* using fontawesome icon as pseudo elements */
  content: url(data:image/svg+xml,${encodeURIComponent(
    renderToString(<FontAwesomeIcon icon={faAngleLeft} />)
  )});
  left: 11rem;
`;

const chevronNextArrow = css`
  ${chevronArrowBaseStyles}
  /* using fontawesome icon as pseudo elements */
  content: url(data:image/svg+xml,${encodeURIComponent(
    renderToString(<FontAwesomeIcon icon={faAngleRight} />)
  )});
  right: 11rem;
`;

export const bottomArrowsStyles = css`
  .carousel {
    position: relative;

    .slide {
      ${p(2)}
    }

    .control-dots {
      .dot {
        margin: 0 4px;
        width: 12px;
        height: 12px;
        background: ${colors.gray};

        &.selected {
          background: ${({ activeColor }) => activeColor || colors.aquaMarine};
        }
      }
    }

    .control-arrow {
      top: unset;
      bottom: -48px;
      opacity: 1;

      ${breakpoint('desktop')`
        bottom: -55px;
      `}

      &:hover {
        background: transparent;
        box-shadow: ${theme.shadows.mediumStrong};
      }

      &.control-disabled {
        display: block;
        pointer-events: none;
        opacity: 0.3;
      }

      &.control-prev {
        left: 1rem;

        &:before {
          ${({ arrowType }) => (arrowType === 'chevron' ? chevronPrevArrow : solidPrevArrow)}
        }
      }

      &.control-next {
        right: 1rem;

        &:before {
          ${({ arrowType }) => (arrowType === 'chevron' ? chevronNextArrow : solidNextArrow)}
        }
      }

      // If IE
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        display: none !important;
        visibility: hidden !important;
      }
    }
  }
`;
